import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';

import { useRedirectToLogin } from '@/hooks/redirectTo.hook';
import { DoohInventoryHeaderStyled } from './DoohInventoryHeader.styled';

const DRIVE_EXCEL_URL = 'https://drive.google.com/drive/folders/1NAYan1x3-3WnTIxAz8QmhKjdofUxRIJU';

function DoohInventoryHeader() {
  const { formatMessage } = useIntl();
  const redirectToLogin = useRedirectToLogin();

  const handleLogoClick = () => redirectToLogin();

  return (
    <DoohInventoryHeaderStyled className="doohInventory__header">
      <span className="doohInventory__headerLogo" onClick={handleLogoClick}>
        <img alt="taptapLogo" id="taptapLogo" src="/assets/images/logos/logoTapTap.png" />
      </span>
      <h4 className="doohInventory__headerTitle">
        {formatMessage({
          defaultMessage: 'Discover our ',
          id: 'doohInventory.header.title1'
        })}
        <span className="doohInventory__headerTitle--strong">
          {formatMessage({
            defaultMessage: 'Screen Inventory',
            id: 'doohInventory.header.title2'
          })}
        </span>
      </h4>
      <div className="doohInventory__headerButton">
        <a href={DRIVE_EXCEL_URL} rel="noopener noreferrer" style={{ textDecoration: 'none' }} target="_blank">
          <ButtonUI
            icon="fa-solid fa-arrow-down-to-line"
            iconPosition="left"
            id="globalDownloadAllButton"
            size="small"
            text={formatMessage({
              defaultMessage: 'Download Inventory',
              id: 'doohInventory.download.title'
            })}
            type="primary"
            visible
          />
        </a>
      </div>
    </DoohInventoryHeaderStyled>
  );
}

export default DoohInventoryHeader;
